import { Asset } from "../models/asset";
import { ITruckerPayPlanData } from "../models/truckerPayPlan";

import ApiService from "../services/api";

export const fetchContractDetails = async (
  asset: Asset,
): Promise<ITruckerPayPlanData> => {
  const apiService = new ApiService();

  const params = new URLSearchParams();
  
  const odometerIntegerValue = Math.trunc(asset.odometer ?? 0);
  const hourmeterIntegerValue = Math.trunc(asset.hourmeter ?? 0);

  if (odometerIntegerValue > 0) params.append("odometer", String(odometerIntegerValue));
  if (hourmeterIntegerValue > 0) params.append("hourMeter", String(hourmeterIntegerValue));

  const response = await apiService.get<ITruckerPayPlanData>(
    `/assets/${asset.chassis}/trucker-pay-plan?${params.toString()}`,
  );
  if (response.status !== 200 || !response.data) {
    throw new Error("Erro ao buscar detalhes do contrato");
  }
  return response.data;
};

export const fetchContractDetailsById = async (id: string): Promise<{ name: string, contract: string, id: number }> => {
  const apiService = new ApiService();
  const response = await apiService.get<{ name: string, contract: string, id: number }>(`/plans/trucker-pay/${id}`);
  if (response.status !== 200 || !response.data) {
    throw new Error("Erro ao buscar detalhes do contrato");
  }
  return response.data;
};